import { Hyperlink } from '@databases/types/database';

import { AsyncOperation, AsyncOperationStatus, validateStatus } from '../redux';

import { HyperlinksState } from './slice';

type ContextState = {
  hyperlinks: HyperlinksState;
};

/**
 * Returns the hyperlink with the specified URL from the store. If the hyperlink is not loaded, an error is thrown.
 * @throws If the hyperlink is not loaded, an error is thrown.
 */
export function selectHyperlinkRequired(
  state: ContextState,
  { url }: { url: string }
): Hyperlink {
  validateStatus(selectHyperlinkStatus(state, { url }));

  const hyperlink = selectHyperlinkOptional(state, { url });
  if (!hyperlink) {
    throw new Error(`Hyperlink ${url} is not loaded.`);
  }
  return hyperlink;
}

/**
 * Returns the hyperlink with the specified URL from the store. If the link is not loaded, undefined is returned.
 * If there was an error loading the hyperlink, undefined is returned.
 */
export function selectHyperlinkOptional(
  state: ContextState,
  { url }: { url: string | undefined }
): Hyperlink | undefined {
  if (url == null) {
    return undefined;
  }

  if (selectHyperlinkStatus(state, { url })?.status === AsyncOperationStatus.ERROR) {
    return undefined;
  }

  return state.hyperlinks.hyperlinks[url];
}

/**
 * Returns the load status of the loadHyperlink action for the given URL.
 */
export function selectHyperlinkStatus(
  state: ContextState,
  { url }: { url: string | undefined }
): AsyncOperation<void> | undefined {
  if (url == null) {
    return undefined;
  }

  return state.hyperlinks.hyperlinkStatus[url];
}
